




























import { Vue, Component } from "vue-property-decorator";
import CustomContainer from './Globals/CustomContainer.vue';
import CustomModal from '@/components/Modals/wrapper/modalWrapper.vue';
import ModalHeader from '@/components/molecule.modal.header.vue';
import UgcUploading from '@/components/molecule.modal.ugcUploadingImage.vue';

@Component({
  components: {
    CustomContainer,
    CustomModal,
    ModalHeader,
    UgcUploading
  }
})
export default class UgcUploadingImage extends Vue {
  get translations() {
    return this.$store.state.translations?.data;
  }
}
